export default "__VITE_ASSET__88a11d34__"